module.exports = __webpack_public_path__ + "img/logo.b6c7f2e9.svg";